<template>
  <div id="group-details" class="chat-navbar">
      <!-- <p>This is chat group details</p> -->
      <!-- <vs-button size="small" @click="getGroupDetails">Group Details</vs-button> -->
      <div class="nav-chat-details" @click="getGroupDetails">
        <div>
          <!-- <vs-avatar class="border-2 border-solid border-white" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/20201027120008350001/Default/7eWD1zcDwXfAbGLL.png" size="40px" /> -->
          <div style="display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; background: rgba(var(--vs-primary), 1); border-radius: 50%; margin-right: 5px;">
                  <span style="font-siz: 70px; color: rgba(var(--vs-secondary), 1);" class="material-icons-outlined">groups</span>
          </div>
        </div>
        <div class="group-details-holder">
            <strong>
            <span>{{groupUsersFullNameArray.slice(0, 3).join(', ')}} </span>
            <span id="groupShowMoreUsers" v-if="groupUsersFullNameArray.length > 3">
              {{groupUsersFullNameArray.length - 3}} More
            </span>
            <div id="allUserShown" v-if="groupUsersFullNameArray.length > 2">
              {{groupUsersFullNameArray.slice(3, groupUsersFullNameArray.length).join(', ')}}
            </div>
            
            <svg 
            style="left: 7px; top: 5px; position: relative;"
            width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(43, 44, 51, 0.7)" gradientColor1="rgba(43, 44, 51, 0.7)" gradientColor2="rgba(43, 44, 51, 0.7)"><path d="M12.012 2.25c.734.009 1.466.093 2.182.253a.75.75 0 01.582.649l.17 1.527a1.384 1.384 0 001.928 1.116l1.4-.615a.75.75 0 01.85.174 9.793 9.793 0 012.204 3.792.75.75 0 01-.271.826l-1.242.915a1.38 1.38 0 00.001 2.226l1.242.915a.75.75 0 01.272.826 9.799 9.799 0 01-2.204 3.792.75.75 0 01-.848.175l-1.406-.616a1.381 1.381 0 00-1.927 1.113l-.169 1.526a.75.75 0 01-.572.648 9.518 9.518 0 01-4.406 0 .75.75 0 01-.572-.648l-.168-1.524a1.382 1.382 0 00-1.925-1.11l-1.407.616a.75.75 0 01-.849-.175 9.798 9.798 0 01-2.203-3.796.75.75 0 01.271-.826l1.243-.916a1.381 1.381 0 000-2.226l-1.243-.914a.75.75 0 01-.271-.826 9.793 9.793 0 012.204-3.792.75.75 0 01.85-.174l1.4.615a1.387 1.387 0 001.93-1.118l.17-1.526a.75.75 0 01.583-.649c.717-.16 1.45-.244 2.201-.253zm0 1.5a9.137 9.137 0 00-1.354.117l-.109.977A2.886 2.886 0 016.525 7.17l-.898-.394a8.293 8.293 0 00-1.348 2.317l.798.587a2.88 2.88 0 010 4.643l-.799.588c.32.842.776 1.626 1.348 2.322l.905-.397a2.882 2.882 0 014.017 2.318l.11.984c.889.15 1.798.15 2.687 0l.11-.984a2.881 2.881 0 014.018-2.322l.905.396a8.3 8.3 0 001.347-2.318l-.798-.588a2.88 2.88 0 010-4.642l.796-.588a8.293 8.293 0 00-1.348-2.317l-.896.393a2.884 2.884 0 01-4.023-2.324l-.11-.976a8.99 8.99 0 00-1.333-.117zM12 8.25a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"></path></svg>

            </strong>
        </div>
      </div>

    <!-- <VuePerfectScrollbar> -->
    <div class="show-group-details vertical_scrollbar" v-if="showGroupDetails">
      <div class="chat_group_details">
          <vs-divider class="mt-0"/>
              <!-- {{groupDetails}} -->
              <div style="display: flex; justify-content: center; align-items: center; width: 60px; height: 60px; background: rgba(var(--vs-primary), 1); border-radius: 50%; margin: 0 auto;">
                  <span style="font-size: 40px; color: rgba(var(--vs-secondary), 1);" class="material-icons-outlined">groups</span>
              </div>
              <!-- <img :src="groupDetails.group_picture" :alt="groupDetails.group_name"> -->
                <h4 class="group_name">{{groupDetails.group_name}}</h4>
                <h6 class="group_creator">Created by {{groupAdmin}}</h6>
      </div>

      <div class="group_user_list px-4">
          <!-- <vs-divider/> -->
          <vs-tooltip text="Add User" class="add_user_tooltip">
              <vs-button color="primary" icon="person_add" class="add_user_btn" @click="addGroupUser"></vs-button>
          </vs-tooltip>
          
          <vs-divider/>
          <ul>
              <h6>{{groupUsers.length}} participants</h6>
              <!-- <vs-divider/> -->
              <li v-for="(user, index) in groupUsers" :key="index">
                  <div class="flex flex-wrap justify-between items-center">
                    <div class="inline-flex items-center">
                      <vs-avatar class="border-2 border-solid border-white" :src="user.picture" style="min-width: 40px; height: 40px;" />
                      <span style="display: inline-block;">{{user.first_name}} {{user.last_name}}</span>
                    </div> 

                    <!-- Only admin can   -->
                    <!-- <span class="" v-if="canRemoveGroupUser">
                    <vs-button color="danger" size="small" @click="openRemoveGroupUserConfirm(user.type, user.user_id)">Remove</vs-button>
                    </span> -->

                     <!-- Only current logged in user can   -->
                    <!-- <span v-else-if="(user.user_id === currentUserId)">
                      <vs-tooltip text="You can remove yourself" style="display: inline-block;" color="success">
                        <vs-button color="danger" size="small" @click="openRemoveGroupUserConfirm(user.type, user.user_id)">Remove</vs-button>
                      </vs-tooltip>
                    </span> -->

                    <!-- <span v-else>
                      <vs-tooltip text="You are not allowed" style="display: inline-block;" color="warning">
                        <vs-button color="danger" size="small" disabled >Remove</vs-button>
                      </vs-tooltip>
                    </span> -->
                    <p v-if="user.is_group_owner === 0">
                      <vs-button color="danger" size="small" @click="openRemoveGroupUserConfirm(user.type, user.user_id)">
                        <span v-if="user.user_id === currentUserId">Leave Group</span>
                        <span v-else>Remove</span>
                      </vs-button>
                    </p>
                  </div>
                  
              </li>
          </ul>
      </div>
    </div>
    <!-- </VuePerfectScrollbar> -->
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { fetchGroupDetails, fetchGroupUserList, removeGroupUser } from '@/api/message'
import {EventBus} from './mixin/EventBus'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'CharGroupDetails',
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      groupAdmin:'',
      currentUserId:null,
      canRemoveGroupUser:false,
      groupUsers: [],
      groupUsersFullNameArray:[],
      groupDetails: [],
      showGroupDetails: false,
      removingGroupUser: false,
      addingGroupUser: false,
      mounted: false
    }
  },
  props: ['hideGroupsDetails'],
  computed: {
    ...mapGetters(['chats', 'UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'tabActive'])
  },
  mounted () {
    this.currentUserId = JSON.parse(localStorage.userInfo).id
    this.mounted = true
    this.getGroupDetails()
    // this.showGroupDetails = false
    EventBus.$on('groupUserAddedSuccess', () => {
      this.getGroupDetails()
      this.addingGroupUser = true
    })
  },
  watch: {
    GroupActiveThread: {
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          
          this.getGroupDetails().then(() => {
            this.showGroupDetails = false
          })
        }
        // 
        // 
        
      }

    },
    deep: true
  },
  methods: {
    async getGroupDetails () {
      const group_id = this.GroupActiveThread
      const customer_id = localStorage.getItem('customer_id')
      
      try {
        const data = await fetchGroupDetails(group_id)
        // 
        // 
        this.groupDetails = data.data.data.group_Details
      } catch (e) {
        console.log(e) 
      }
      
      try {
        const data2 = await fetchGroupUserList(customer_id, group_id)
        this.groupUsers = data2.data.data.group_user_list
        this.groupUsersFullNameArray = this.groupUsers.map((ele) => {
          return `${ele.first_name} ${ele.last_name}`
        })
        const groupAdmin = this.groupUsers.filter((ele) => ele.is_group_owner)[0]
        if (groupAdmin) {
          if(typeof groupAdmin.middle_name !== "undefined" && groupAdmin.middle_name !== "") {
            this.groupAdmin = `${groupAdmin.first_name} ${groupAdmin.middle_name} ${groupAdmin.last_name}`
          } else {
            this.groupAdmin = `${groupAdmin.first_name} ${groupAdmin.last_name}`
          }
          
        } else {
          this.groupAdmin = '(N/A)'
        }

        //Checking if current logged user is creator of the group if no remove delete user button
        let creator = null
        creator = this.groupUsers.filter((x) => x.user_id === JSON.parse(localStorage.userInfo).id && x.is_group_owner)
        
        if (creator.length) {
          this.canRemoveGroupUser = true
        } else {
          this.canRemoveGroupUser = false
        }
      } catch (e) {
        console.log(e)
      }
    
      if (!this.removingGroupUser && !this.addingGroupUser) {
        this.showGroupDetails = !this.showGroupDetails
      } else {
        this.removingGroupUser = false
        this.addingGroupUser = false
      }

      if (this.mounted) {
        this.showGroupDetails = false
        this.mounted = false
      }
      
    },
    async getGroupUsersList () {
      const group_id = this.GroupActiveThread
      const customer_id = localStorage.getItem('customer_id')
      const data = await fetchGroupUserList(customer_id, group_id)
    //   
    },
    openRemoveGroupUserConfirm (user_type, user_id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: user_id === this.currentUserId ? 'Are you sure to leave this group ?' : 'Are you sure to remove this user ?',
        accept:this.removeGroupUser,
        acceptText:'Yes',
        cancelText:'No',
        parameters:[user_type, user_id]
      })
    },
    async removeGroupUser (delete_user_data) {
      const user_type = delete_user_data[0]
      const user_id = delete_user_data[1]
      // 
      // 
      this.removingGroupUser = true

      try {
        const group_id = this.GroupActiveThread
        const customer_id = localStorage.getItem('customer_id')

        const payload = {
          group_id, 
          'user_list' : [
            {
              user_id,
              'type' : user_type
            }
          ],
          customer_id
        }

        // 
        const data = await removeGroupUser(payload)
        // 
        this.getGroupDetails()

      } catch (e) {
        
      }
    },
    addGroupUser () {
      EventBus.$emit('addGroupUser')
    }
  } 
}
</script>

<style>
.group-details-holder:hover {
    color: #8a8a8a;
}

#groupShowMoreUsers{
  display: inline-block;
  padding: 3px 10px;
  background: #f8f3fc;
  border-radius: 2px;
  box-shadow: 0px 0px 2px grey;
  margin-left: 5px;
  font-size: 12px;
  cursor: default;
}

#allUserShown {
  max-width: 60%;
  display: none;
  white-space: normal;
  position: absolute;
  background-color: white;
  height: auto;
  padding: 5px;
  z-index: 1;
  border-radius: 3px;
  box-shadow: 0px 0px 2px #00000063;
  margin-top: 1px;
}

#groupShowMoreUsers:hover + #allUserShown {
  display: block;
  background: white;
  border-radius: 1px;
  box-shadow: 0px 0px 2px grey;
  margin-left: 5px;
}

.chat-navbar {
    /* right: 0; */
    background: white;
    padding: 10px 20px;
    /* position: absolute; */
    width: 100%;
    /* left: 0;
    top: 6px;
    z-index: 1000;
    margin: auto; */
    box-shadow: 0px 0px 10px #41cfdd26;
    border-radius: 3px;
}

.chat_group_details img{
    width: 60px;
    margin: auto;
    display: block;
}
.chat_group_details .group_name{
    margin-top:10px;
    text-align: center;
}

.chat_group_details .group_creator{
    margin-top:10px;
    text-align: center;
    text-overflow: ellipsis;
    font-size: 12px;
    color: rgb(138, 141, 145);
    font-weight: 500;
}

.group_user_list .group-user-avatar {
    position: relative;
    top: 20px;
}

.group_user_list .add_user_tooltip{
    float: right;
    margin-bottom: 15px;
    margin-right: 40px;
}

.group_user_list .add_user_btn{
    width: 81px !important;
}

</style>